import MatomoMessage from '@/matomo/message/MatomoMessage';
import { MatomoActions } from '@/matomo/MatomoActions';

export default class MatomoEcommerceView {
  private setEcommerceView = new MatomoMessage([MatomoActions.setEcommerceView, false, false]);
  private trackPageView = new MatomoMessage([MatomoActions.trackPageView]);


  private constructor(ecommerceViewMessage: MatomoMessage) {
    this.setEcommerceView = ecommerceViewMessage;
  }

  public static forCategoryView(categoryName: string): MatomoEcommerceView {
    return new MatomoEcommerceView(new MatomoMessage([MatomoActions.setEcommerceView, false, false, categoryName]));
  }

  public static forProductView(sku: string, name: string, categoryName: string): MatomoEcommerceView {
    return new MatomoEcommerceView(new MatomoMessage([MatomoActions.setEcommerceView, sku, name, categoryName]));
  }

  public publish() {
    this.setEcommerceView.publish();
    this.trackPageView.publish();
  }


}
